import React from 'react';
import PropTypes from 'prop-types';

import { withStyles, Grid, Typography, Box } from '@material-ui/core';
import { convertTime, getSecondsDifferent } from 'helpers/Utility';

import styles from './styles';
import WithAppBar from 'components/withAppBar';
import {
  neutralNr40,
  secondarySc50,
  stateErrorRaya,
  textPrimary
} from 'common/colors';
import PinInput from 'react-pin-input';
import { DrawerInfo, PaperTimer, WithTransition } from 'components';
import { getRemainingTimer } from 'helpers/timer';

const OTP_HEADER = 'Masukkan kode OTP yang dikirim melalui SMS ke nomor ';
const maskingPhoneChangeNumber = (number = '') => {
  if (!number) return number;
  return `**** **** ${number.slice(-3)}`;
};

const InputOTPComponent = ({
  classes,
  completedHandler,
  phoneNo,
  error,
  resendHandler,
  // errorCount,
  limitedReceiveOtp,
  timer,
  setTimer,
  resetError,
  history
}) => {
  const PIN_LENGTH = 6;
  // const longerTimer = 60 * 10; /* 10 min */

  const stored = localStorage.getItem('otpFreeze');
  const { freezeTime } = stored ? JSON.parse(stored) : {};

  const [isDrawerFreeze, setIsDrawerFreeze] = React.useState(false);
  const [freezeTimer, setFreezeTimer] = React.useState(
    getSecondsDifferent(freezeTime)
  );
  const [isFreeze, setIsFreeze] = React.useState(freezeTime !== undefined);
  let pinInputRef = React.useRef();

  const pinStyle = {
    display: 'flex',
    justifyContent: 'space-evenly'
  };

  const focusStyle = {
    borderBottomColor:
      error === 'incorrect_otp' ? stateErrorRaya : secondarySc50
  };

  const inputStyle = {
    width: '45px',
    height: '65px',
    margin: '4px',
    border:
      error === 'incorrect_otp'
        ? `1px solid ${stateErrorRaya}`
        : `1px solid ${neutralNr40}`,
    borderBottomColor:
      error === 'incorrect_otp' ? stateErrorRaya : `1px solid ${neutralNr40}`,
    borderRadius: '8px',
    fontWeight: 'Bolder',
    fontFamily: 'Lato',
    color: textPrimary,
    fontSize: 20
  };

  const remainingFrezeTime = React.useCallback(getRemainingTimer(freezeTimer), [
    freezeTimer
  ]);

  React.useEffect(() => {
    if (error === 'otp_temporary_locked') {
      setIsDrawerFreeze(true);
      setIsFreeze(true);
    }
  }, [error]);

  React.useEffect(() => {
    if (freezeTime) {
      const secs = getSecondsDifferent(freezeTime);
      if (secs > 0) {
        setFreezeTimer(secs);
        setIsFreeze(true);
      } else {
        setFreezeTimer(0);
        setIsFreeze(false);
      }
    } else {
      setFreezeTimer(0);
      setIsFreeze(false);
    }
  }, [freezeTime]);

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer(prev => prev - 1);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timer, setTimer]);

  React.useEffect(() => {
    if (!isFreeze) return;

    const intervalFreeze = setInterval(() => {
      if (freezeTimer > 0) {
        setFreezeTimer(prev => prev - 1);
      } else {
        setIsFreeze(prev => !prev);
        resetError();
        setIsDrawerFreeze(false);
        localStorage.removeItem('otpFreeze');
      }
    }, 1000);

    return () => {
      clearInterval(intervalFreeze);
    };
    // eslint-disable-next-line
  }, [freezeTimer, setFreezeTimer, isFreeze]);

  const onFreezeHandler = () => {
    setIsDrawerFreeze(prev => !prev);
  };

  const drawerFreezeOtp = (
    <DrawerInfo
      actionButtonLabel="Oke"
      onActionHandler={onFreezeHandler}
      opened={isDrawerFreeze}
      setOpened={setIsDrawerFreeze}
      title="Tunggu beberapa saat lagi"
    >
      <Typography color="textSecondary" gutterBottom variant="h6">
        Anda telah beberapa kali salah memasukan kode OTP. Coba lagi dalam:
      </Typography>
      <div className={classes.gridTimer}>
        <PaperTimer label="Menit" value={remainingFrezeTime.minutes} />
        <PaperTimer label="Detik" value={remainingFrezeTime.seconds} />
      </div>
    </DrawerInfo>
  );

  const changedHandler = value => {
    if (value.length === 5 && error) {
      pinInputRef.clear();
      resetError();
    }
  };

  return (
    <WithTransition>
      {drawerFreezeOtp}
      <WithAppBar history={history} noPadding title="Ubah Nomor HP">
        <Box style={{ padding: '16px' }}>
          <Grid
            container
            direction="column"
            justify="center"
            spacing={2}
            wrap="nowrap"
          >
            <Grid container direction="column" item spacing={1}>
              <Grid item>
                <img
                  aria-label="referral"
                  src="/images/assets/icon-input-otp-change-phone-number.svg"
                  type="image/svg+xml"
                />
              </Grid>
              <Grid item>
                <Typography color="textPrimary" variant="h4">
                  Verifikasi nomor HP-mu dulu, ya.
                </Typography>
              </Grid>
              <Grid item>
                <Typography color="textSecondary" variant="h6">
                  {OTP_HEADER}
                  <strong>{maskingPhoneChangeNumber(phoneNo)}</strong>
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              {isFreeze ? (
                <Typography align="center" color="textSecondary">
                  Anda telah beberapa kali salah memasukan kode OTP coba lagi
                  pada ({convertTime(freezeTimer)})
                </Typography>
              ) : (
                <>
                  <PinInput
                    disabled={limitedReceiveOtp}
                    initialValue=""
                    inputFocusStyle={focusStyle}
                    inputMode="number"
                    inputStyle={inputStyle}
                    length={PIN_LENGTH}
                    onChange={changedHandler}
                    onComplete={completedHandler}
                    ref={n => (pinInputRef = n)}
                    secret={false}
                    style={pinStyle}
                    type="numeric"
                  />
                  {error === 'incorrect_otp' && (
                    <Typography className={classes.warn} variant="caption">
                      Kode verifikasi salah, cek dan masukkan kembali.
                    </Typography>
                  )}
                  <Grid
                    container
                    direction="row"
                    item
                    justifyContent="center"
                    spacing={1}
                    style={{ marginTop: '8px' }}
                  >
                    {limitedReceiveOtp ? (
                      <Typography
                        align="center"
                        className={classes.limitedReceiveOtp}
                        variant="h6"
                      >
                        Proses verifikasi kamu melebihi batas maksimal
                        percobaan, kamu bisa coba lagi 1x24 jam, ya.
                      </Typography>
                    ) : (
                      <Grid
                        alignItems="center"
                        container
                        direction="column"
                        item
                        justifyContent="center"
                      >
                        <Grid item>
                          <Typography className={classes.noteText} color="textSecondary">
                            Belum terima kode OTP?
                          </Typography>
                        </Grid>
                        <Grid
                          container
                          direction="row"
                          justifyContent="center"
                          item
                        >
                          <Grid item>
                            <Typography
                              align="center"
                              className={
                                timer === 0
                                  ? classes.resendOtpActive
                                  : classes.resendOtpInActive
                              }
                              onClick={resendHandler}
                              variant="h6"
                            >
                              Kirim ulang
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography
                              align="center"
                              className={classes.subtitle}
                              color="textPrimary"
                              onClick={resendHandler}
                              variant="h6"
                            >
                              {timer !== 0 && '(' + convertTime(timer) + ')'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Box>
      </WithAppBar>
    </WithTransition>
  );
};

InputOTPComponent.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  completedHandler: PropTypes.func,
  error: PropTypes.string,
  handler: PropTypes.func,
  history: PropTypes.object,
  icon: PropTypes.object,
  limitedReceiveOtp: PropTypes.bool,
  phoneNo: PropTypes.string,
  resendHandler: PropTypes.func,
  resetError: PropTypes.func,
  setTimer: PropTypes.func,
  timer: PropTypes.number
};

export default withStyles(styles)(InputOTPComponent);
